import Dropdown from './dropdown';
import Build from './build';

/**
 * Set and Initalize Dropdowns for filters.
 */
const dropdownEls = [...document.querySelectorAll('.em-content-category__select')];
if (dropdownEls) {
	dropdownEls.map((el) => new Dropdown(el));
}

/**
 * Using Filter term_ids set the appropriate resource item content.
 */
const targetNode = [...document.querySelectorAll('.em-content-category__select-container')];
if (targetNode.length) {
	targetNode.map((node) => new Build(node));
}
